import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowLeft: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: true,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.9454 3.99995C14.1454 3.99995 14.4454 4.09995 14.6454 4.19995C15.0454 4.59995 15.1454 5.19995 14.7454 5.59995L9.24536 11.9999L14.7454 18.3C15.1454 18.6999 15.0454 19.4 14.6454 19.7C14.2454 20.1 13.5454 20 13.2454 19.6L7.24536 12.5999C6.94536 12.1999 6.94536 11.7 7.24536 11.3L13.2454 4.29995C13.3454 4.09995 13.6454 3.99995 13.9454 3.99995Z',
    })
  )
}
